export const LoginMapper = {
  hydrate(data) {
    return {
      ...data,
      access_token: `Bearer ${data.access_token}`,
    };
  },
};
